import React from "react";
import classes from "./card.module.css";

export const Card = (props) => {
  return (
    <div className={`${classes["card"]} ${props.className}`}>
      {props.children}
    </div>
  );
};
